export const  AccionMovInvBackEnum  = Object.freeze({
    ACTUALIZAR: 1,
    CREAR: 2,
    BORRAR: 3
})